module.exports = __webpack_public_path__ + "img/wechat_contact.ba6764fe.jpg";